import { atomWithImmer } from "jotai/immer";
// type TApiTeamData = Pick<IUserAndSystemInfoResponse, "team">;
export var teamAtom = atomWithImmer(null);
teamAtom.debugLabel = "teamState";